export const EditViewString = (hasWriteAccess) => {
    if (hasWriteAccess) {
        return "edit"
    }
    else {
        return "view"
    }
};

